import AddressCreate from "@/models/address/AddressCreate";

export default class SampleOrderRequestData {
	public Address!: AddressCreate;
	public Email!: string | null;
	public Phone!: string | null;
	public Comment!: string | null;
	public ItemIds!: string[];
}
